import React, { Component } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import md5 from "md5";
import { __, fixDate, forceSatoshiFormat, Event, decode, sendNotfication } from 'utils/Helper';
import socket from "utils/Socket";
import C from "utils/Constant";
import UserLink from "../../components/User/Stat/Modal";

function MakeCircle({ number: result, t, type }) {
  const copyHash = (value) => {
    var el = document.createElement("input");
    el.value = value;
    document.body.appendChild(el);
    el.select();
    el.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(el);
    sendNotfication("Copied !", "info", "top-center");
  };

  if (!__.isUndefined(result.num)) {
    return (
      <>
        <div
          className={"avatar-box align-self-center mx-1 my-1 cpt thumb-" + type}
          data-tip={t("click_to_copy_hash") + ":" + result.hash}
          onClick={(e) => copyHash(result.hash)}
        >
          <span className="avatar-title bg-purple rounded text">{result.num}</span>
        </div>
      </>
    );
  }
  return (
    <>
      <div className={"avatar-box align-self-center mx-1 my-1 thumb-" + type}>
        <span className="avatar-title bg-purple rounded text">{result}</span>
      </div>
    </>
  );
}

class PlayerRow extends React.Component {
  render() {
    const { array, key, clicked } = this.props;
    let color = "text-success";
    let profit = __.toNumber(array.profit);
    let coin = __.upperCase(array.coin);

    if (profit === 0 || profit === 0.0 || profit === "0.00000000") {
      profit = "- " + array.amount;
      color = "text-warning";
    }

    return (
      <>
        <tr className={color} key={key}>
          <td>
            <UserLink id={array.uid} clicked={clicked} username={array.name} isWinner={color} />
          </td>
          <td className="num-style">
            <img src={"/assets/images/" + coin + ".png"} className={"mini-coin-8"} alt={coin} />
            {forceSatoshiFormat(array.amount)} {coin}
          </td>
          <td className="num-style">
            <img src={"/assets/images/" + coin + ".png"} className={"mini-coin-8"} alt={coin} />
            {forceSatoshiFormat(profit)} {coin}
          </td>
        </tr>
      </>
    );
  }
}

function sortByWinner(input) {
  function r(c) {
    return c.profit ? -c.profit : null;
  }
  return __.sortBy(input, r);
}

class GameModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      loading: true,
      gid: null,
      playerRow: [],
      numbers: [],
      players: [],
      busted: null,
      date: null,
      sha256: null,
      hash: null,
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.modal) {
      this.setState({ show: false });
    }
  }

  componentDidMount() {
    socket.on(C.GAME_DETAILS, (data) => this.gameInfo(decode(data)));

    Event.on("force_modal_game", () => {
      this.setState({
        haveData: "no",
        playerRow: [],
        busted: null,
        date: null,
        sha256: null,
        hash: null,
        gid: null,
        loading: true,
        show: true,
        effect: "zoomIn",
      });
    });
  }

  handleClose = () => {
    this.setState({ show: false, loading: true, effect: "zoomOut" });
  };

  gameInfo(response) {
    if (!response.info) {
      this.setState({ show: false, loading: true, effect: "zoomOut" });
      return;
    }
    this.setState({ loading: false, playerRow: [], haveData: "ok" });

    let gameInfo = response.info;
    let busted;

    if (
      gameInfo.busted !== null &&
      gameInfo.busted !== undefined &&
      gameInfo.busted !== "undefined" &&
      gameInfo.busted !== ""
    ) {
      busted = gameInfo.busted;
    } else {
      busted = gameInfo.numbers;
    }

    this.setState({
      busted: busted,
      sha256: md5(gameInfo.hash),
      hash: gameInfo.hash,
      date: gameInfo.date,
      gid: gameInfo.gid,
    });

    let sort = sortByWinner(response.data);
    sort = __.xor(sort);

    let uniq = [];
    sort.forEach((player, i) => {
      var find = __.findIndex(uniq, function (o) {
        return o.uid === player.uid;
      });
      if (find === -1) uniq.push(player);
    });

    this.setState({ players: uniq });
  }

  render() {
    const { t } = this.props;
    let { busted, date, sha256, hash, playerRow, gid, loading } = this.state;
    let heading = "h1";
    let color = busted >= 1.9 ? "success" : "danger";

    if (__.isArray(busted)) {
      heading = "h2";
      busted = busted.map((number, i) => (
        <MakeCircle key={__.toString(i)} t={t} type={"md"} number={number} />
      ));
    }

    var players = this.state.players.map((array, i) => (
      <PlayerRow key={__.toString(i)} clicked={this.handleClose} array={array} />
    ));

    return (
      <Modal
        size="md"
        centered={true}
        backdrop={"static"}
        show={this.state.show}
        onHide={this.handleClose}
        aria-labelledby="game-md-modal"
        className={"animated " + this.state.effect}
      >
        <Modal.Header className="Header">
          {t("game_stats")}{" "}
          <button type="button" className="close p-2" onClick={this.handleClose}>
            <i className={"mdi mdi-close"} />
          </button>
        </Modal.Header>
        {this.state.players && (
          <Modal.Body>
            {loading ? (
              <div className="text-center" style={{ minHeight: 200 }}>
                <div className="spinner-grow text-white my-1 user-loader" role="status" />
              </div>
            ) : (
              <Row className="text-darker pt-0 mb-1 user-detail">
                <Col md={12} sm={12}>
                  <div className="review-box align-item-center p-0">
                    {heading === "h1" ? (
                      <>
                        <h1 className={"text-center my-0 py-0 text-" + color}>
                          {busted}<span className={"font-"}>x</span>
                        </h1>
                        <h5 className={"text-center mt-1 pt-0 text-" + color}>{t("busted")}</h5>
                      </>
                    ) : (
                      <h2 className={"text-center my-0 py-0 text-" + color}>{busted}</h2>
                    )}
                    <Row className="my-3">
                      <Col md={6} sm={6} className="text-success">Game ID: {gid}</Col>
                      <Col md={6} sm={6} className="text-white text-right">{t("date")}: {fixDate(date)}</Col>
                    </Row>
                  </div>
                </Col>
                <Col md={12} sm={12} className="text-center">
                  <div className="form-group">
                    <div className="input-group">
                      <div className="input-group-append">
                        <span className="input-group-text h-40 bg-cs44">HASH</span>
                      </div>
                      <input type="text" className="form-control no-radius pointer mb-2 bg-cs44" value={__.toString(hash)} readOnly={true} />
                    </div>
                    <div className="input-group">
                      <div className="input-group-append">
                        <span className="input-group-text h-40 bg-cs44">MD5</span>
                      </div>
                      <input type="text" className="form-control no-radius pointer bg-cs44" value={__.toString(sha256)} readOnly={true} />
                    </div>
                  </div>
                </Col>
              </Row>
            )}
            {loading ? (
              <div className="text-center" style={{ minHeight: 200 }}>
                <div className="text-info my-2 user-loader" role="status" />
              </div>
            ) : (
              <>
                <h4 className={"mb-3 mt-0 text-yellow"}>Players List</h4>
                <div className="table-responsive game-stats">
                  <table className="table">
                    <thead className="table-header">
                      <tr>
                        <th>{t("player")}</th>
                        <th>{t("bet")}</th>
                        <th>{t("profit")}</th>
                      </tr>
                    </thead>
                    <tbody>{players}</tbody>
                  </table>
                  {players.length === 0 && (
                    <p className="text-center text-muted">No one played on this round</p>
                  )}
                </div>
              </>
            )}
          </Modal.Body>
        )}
      </Modal>
    );
  }
}

export default GameModal;
